'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var users = require('./users');
var groups = require('./groups');

module.exports = function (models) {
  return _extends({}, models, {
    users: models.users ? _ramda2.default.mergeDeepLeft(models.users, users) : users,
    groups: models.groups ? _ramda2.default.mergeDeepLeft(models.groups, groups) : groups
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/coact/models/withCoactModels.js
// module id = 1790
// module chunks = 0